import { domainEvent, DomainEvent, MessageName } from "@lookiero/messaging";

const CHECKOUT_NOT_MODIFIABLE = "checkout_not_modifiable";

interface CheckoutNotModifiablePayload {
  readonly aggregateId: string;
}

interface CheckoutNotModifiable extends DomainEvent<typeof CHECKOUT_NOT_MODIFIABLE>, CheckoutNotModifiablePayload {}

interface CheckoutNotModifiableFunction {
  (payload: CheckoutNotModifiablePayload): CheckoutNotModifiable;
}

const checkoutNotModifiable: CheckoutNotModifiableFunction = ({ aggregateId }) =>
  domainEvent({ aggregateId, name: CHECKOUT_NOT_MODIFIABLE });

const isCheckoutNotModifiable = (event: DomainEvent<MessageName>): event is CheckoutNotModifiable =>
  event.name === CHECKOUT_NOT_MODIFIABLE;

export type { CheckoutNotModifiable };
export { CHECKOUT_NOT_MODIFIABLE, checkoutNotModifiable, isCheckoutNotModifiable };
